import * as React from 'react';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { classes, st } from './Breadcrumbs.deprecated.st.css';
import { DATA_HOOKS } from './constants';
import { TextButton, TextButtonPriority } from '../TextButton';
/** Breadcrumbs is a type of navigation scheme which reveals the user’s location in a website or Web application. */
export class Breadcrumbs extends React.Component {
    render() {
        const { className, items, showTrailOnMobileMode, onClick, 'data-hook': dataHook, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, } = this.props;
        const crumbs = items.map((item, index) => {
            const itemProps = {
                ...item,
                onClick: () => {
                    onClick(item);
                },
            };
            return (React.createElement(Breadcrumb, { key: item.id, ...itemProps, isLast: index === items.length - 1 }));
        });
        const noTrailCrumbs = (React.createElement(Breadcrumb, { ...items[items.length - 2], onClick: () => {
                onClick({ ...items[items.length - 2] });
            }, mobileNoTrail: true }));
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => (React.createElement("nav", { className: st(classes.root, { rtl }, className), "data-hook": dataHook, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "data-mobile": mobile ? true : undefined },
            React.createElement("ol", { className: classes.list }, mobile && !showTrailOnMobileMode ? noTrailCrumbs : crumbs)))));
    }
}
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.defaultProps = {
    showTrailOnMobileMode: false,
};
const Breadcrumb = ({ value, href, onClick, isLast = false, mobileNoTrail = false, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { "data-hook": DATA_HOOKS.BREADCRUMB, className: classes.crumb, "aria-current": isLast ? 'page' : undefined }, mobileNoTrail ? (React.createElement(TextButton, { as: "a", priority: TextButtonPriority.secondary, href: href, className: classes.button, prefixIcon: React.createElement(ChevronLeft, { "aria-hidden": true }), "data-hook": DATA_HOOKS.BREADCRUMB_BUTTON, onClick: onClick }, value)) : isLast ? (React.createElement("span", { className: st(classes.noButtonCrumb) }, value)) : (React.createElement(TextButton, { as: "a", priority: TextButtonPriority.secondary, href: href, className: classes.button, "data-hook": DATA_HOOKS.BREADCRUMB_BUTTON, onClick: onClick }, value))),
        isLast || mobileNoTrail || (React.createElement(ChevronRight, { "aria-hidden": true, className: classes.chevron }))));
};
//# sourceMappingURL=Breadcrumbs.js.map